<dol-image-picker [imageUris]="securityImageUris" [selectedIndex]="selectedIndex" (selection)="handleSelection($event)">
</dol-image-picker>